<script lang="ts">
  import { useForm, usePage } from '@inertiajs/svelte';
  import { Link } from '@inertiajs/svelte';
  import { Button } from '$lib/components/ui/button';
  import { Card, CardContent, CardHeader, CardTitle } from '$lib/components/ui/card';
  import { Input } from '$lib/components/ui/input';
  import { Label } from '$lib/components/ui/label';
  import { inertia } from '@inertiajs/svelte';
  import { CornerDownLeft } from 'lucide-svelte'; 

  // 1. 核心修改：将字段改回 email_address，与后端 Controller 对齐
  const form = useForm({
    email_address: '',
    password: ''
  });

  const page = usePage();
  $: errors = $page.props.errors || {};
  $: flash = $page.props.flash || {};

  function submit() {
    // 指向 resource :session 的 POST 路径
    $form.post('/login', {
      onError: () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }
</script>

<div class="flex min-h-[calc(100vh-65px-52px)]">
  <div class="hidden md:flex md:w-1/2 bg-neutral-900 text-white p-8 items-center justify-center">
    <div class="w-full max-w-md">
      <a href="/" use:inertia class="inline-flex items-center text-gray-400 hover:text-white mb-12 transition-colors">
        <CornerDownLeft class="mr-2 h-5 w-5" />
        返回首页
      </a>

      <h2 class="text-4xl font-bold mb-4 tracking-tight">分太极光</h2>
      <p class="text-gray-400 text-lg">
        Aurora CMS：为内容主理人打造的极简数字化空间。
      </p>
    </div>
  </div>

  <div class="w-full md:w-1/2 p-6 flex md:items-center justify-center bg-zinc-50/50">
    <div class="w-full max-w-sm space-y-8">
      
      {#if flash?.notice}
        <div class="bg-emerald-50 border border-emerald-200 text-emerald-800 px-4 py-3 rounded-md text-sm">
          {flash.notice}
        </div>
      {/if}
      
      {#if flash?.alert}
        <div class="bg-destructive/10 border border-destructive/20 text-destructive px-4 py-3 rounded-md text-sm">
          {flash.alert}
        </div>
      {/if}

      <Card class="shadow-xl bg-white">
        <CardHeader>
          <CardTitle class="text-center text-2xl font-bold">登录账户</CardTitle>
        </CardHeader>
        <CardContent class="pt-6 space-y-6">
          <form on:submit|preventDefault={submit} class="space-y-5">
            <div class="space-y-2">
              <Label for="email_address">电子邮箱</Label>
              <Input
                id="email_address"
                type="email" 
                placeholder="name@example.com"
                bind:value={$form.email_address}
                required
                class="{errors.email_address ? 'border-destructive focus-visible:ring-destructive' : ''}"
              />
              {#if errors.email_address}
                <p class="text-sm text-destructive">{errors.email_address}</p>
              {/if}
            </div>

            <div class="space-y-2">
              <div class="flex items-center justify-between">
                <Label for="password">密码</Label>
                <Link
                  href="/passwords/new"
                  class="text-sm text-primary hover:underline font-medium"
                >
                  忘记密码？
                </Link>
              </div>
              <Input
                id="password"
                type="password"
                placeholder="请输入密码"
                required
                bind:value={$form.password}
                class="{errors.password ? 'border-destructive focus-visible:ring-destructive' : ''}"
              />
              {#if errors.password}
                <p class="text-sm text-destructive">{errors.password}</p>
              {/if}
            </div>

            <Button
              type="submit"
              class="w-full"
              disabled={$form.processing}
            >
              {#if $form.processing}
                正在验证...
              {:else}
                进入控制台
              {/if}
            </Button>
          </form>

          <div class="relative my-6">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-border"></div>
            </div>
            <div class="relative flex justify-center text-xs uppercase">
              <span class="bg-white px-2 text-muted-foreground">没有账户？</span>
            </div>
          </div>

          <div class="flex flex-col gap-3">
            <Button variant="outline" class="w-full p-0">
              <a href="/register" use:inertia class="w-full h-full flex items-center justify-center">
                立即注册
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  </div>
</div>